var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCrossInRedCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 16,
    fill: "#FF004A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0062 42.0005C27.9597 42.0028 24.3107 39.5664 22.7618 35.8281C21.213 32.0898 22.0697 27.7865 24.9322 24.9265C27.4595 22.3992 31.1431 21.4121 34.5954 22.3372C38.0478 23.2623 40.7444 25.9589 41.6694 29.4112C42.5945 32.8636 41.6075 36.5472 39.0802 39.0745C37.2076 40.9555 34.6603 42.0091 32.0062 42.0005ZM24.0062 32.1725C24.0535 36.5737 27.6473 40.11 32.0487 40.0865C36.4501 40.0627 40.0057 36.488 40.0057 32.0865C40.0057 27.685 36.4501 24.1102 32.0487 24.0865C27.6473 24.0629 24.0535 27.5992 24.0062 32.0005V32.1725ZM29.4152 36.0005L28.0062 34.5905L30.5962 32.0005L28.0062 29.4105L29.4162 28.0005L32.0062 30.5905L34.5962 28.0005L36.0062 29.4105L33.4162 32.0005L36.0062 34.5905L34.5972 36.0005L32.0062 33.4105L29.4162 36.0005H29.4152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCrossInRedCircle);
export default __webpack_public_path__ + "static/media/white-cross-in-red-circle.84ce709da0ea28af5872c258a64043b4.svg";
export { ForwardRef as ReactComponent };